import { callFunctionRaw, resolveFunctionAccessToken } from "@/lib/callFunction";

async function token() {
  const accessToken = await resolveFunctionAccessToken({ refreshIfMissing: true });
  if (!String(accessToken || "").trim()) throw new Error("Session expired. Please sign in again.");
  return accessToken;
}

async function callEvaluationAccess(body) {
  const response = await callFunctionRaw("evaluation-access", body, {
    accessToken: await token(),
    timeoutMs: 12000,
  });
  if (response?.error) {
    const error = new Error(String(response.error || "Evaluation access is unavailable."));
    error.code = String(response.error || "evaluation_access_unavailable");
    throw error;
  }
  return response || {};
}

export async function getEvaluationAccessEligibility() {
  const result = await callEvaluationAccess({ action: "eligibility" });
  return { available: result?.available === true };
}

export async function redeemEvaluationAccessBooking({
  doctorUserId,
  serviceId,
  startsAt,
  durationMinutes,
  practiceId = null,
  careSubject = {},
  idempotencyKey,
} = {}) {
  return callEvaluationAccess({
    action: "redeem",
    doctorUserId,
    serviceId,
    startsAt,
    durationMinutes,
    practiceId,
    careSubject,
    idempotencyKey,
  });
}
